import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

const MAX_CHARS = 160;

export function AlertModal({ isOpen, onClose, onSubmit, isLoading = false }) {
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  const handleSubmit = async () => {
    const trimmed = message.trim();

    if (!trimmed || trimmed.length === 0) {
      return;
    }

    try {
      await onSubmit(trimmed);
      setMessage('');
      onClose();
    } catch (error) {
      console.error('[ALERT_MODAL] Error submitting:', error);
      // El error ya se manejó en AppCore
    }
  };

  const isTrimmedEmpty = message.trim().length === 0;
  const charCount = message.length;
  const isOverLimit = charCount > MAX_CHARS;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Mandar aviso a otros perfiles</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Textarea */}
          <div className="space-y-2">
            <Textarea
              placeholder="Escribe un mensaje para los demás perfiles..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={isLoading}
              maxLength={MAX_CHARS}
              className="resize-none"
              rows={4}
            />
            <div className="flex justify-between items-center text-sm">
              <span
                className={`text-xs ${
                  isOverLimit ? 'text-red-500' : 'text-gray-500'
                }`}
              >
                {charCount}/{MAX_CHARS} caracteres
              </span>
              {isOverLimit && (
                <span className="text-xs text-red-500">
                  Límite excedido
                </span>
              )}
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isTrimmedEmpty || isLoading || isOverLimit}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {isLoading ? 'Enviando...' : 'Enviar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
